import "../styles/design-courses.css";

import psIcon from "../assets/img/software/ps.webp";
import aiIcon from "../assets/img/software/ai.webp";
import indesignIcon from "../assets/img/software/id.webp";
import premiereIcon from "../assets/img/software/pr.webp";
import aeIcon from "../assets/img/software/ae.webp";
import corelIcon from "../assets/img/software/corel.webp";
import maxIcon from "../assets/img/software/3dsmax.webp";
import mayaIcon from "../assets/img/software/maya.webp";
import blenderIcon from "../assets/img/software/blender.webp";
import c4dIcon from "../assets/img/software/c4d.webp";
import nukeIcon from "../assets/img/software/nuke.webp";
import unrealIcon from "../assets/img/software/unreal.webp";
import sketchupIcon from "../assets/img/software/sketchup.webp";
import vmixIcon from "../assets/img/software/vmix.webp";

const courses = [
  { id: 1, name: "Adobe Photoshop", icon: psIcon },
  { id: 2, name: "Adobe Illustrator", icon: aiIcon },
  { id: 3, name: "Adobe InDesign", icon: indesignIcon },
  { id: 4, name: "Adobe Premiere", icon: premiereIcon },
  { id: 5, name: "Adobe After Effects", icon: aeIcon },
  { id: 6, name: "Corel Draw", icon: corelIcon },
  { id: 7, name: "Autodesk 3D Max", icon: maxIcon },
  { id: 8, name: "Autodesk Maya", icon: mayaIcon },
  { id: 9, name: "Blender", icon: blenderIcon },
  { id: 10, name: "Cinema 4D", icon: c4dIcon },
  { id: 11, name: "Nuke Studio", icon: nukeIcon },
  { id: 12, name: "Unreal Engine", icon: unrealIcon },
  { id: 13, name: "SketchUp", icon: sketchupIcon },
  { id: 14, name: "VMix", icon: vmixIcon },
];

const DesignCourses = () => {
  return (
    <section className="design-courses-bg">
      <div className="design-courses__wrapper">
        <h2 className="design-courses__title">
          CÁC KHOÁ HỌC SỬ DỤNG PHẦN MỀM ĐỒ HOẠ CHUYÊN NGHIỆP <br />
          <span className="line"></span>
          <span className="design-courses__highlight">CHỈ VỚI 99.000/BUỔI</span>
        </h2>
        <div className="design-courses__list">
          {courses.map((course) => (
            <div
              className="design-courses__item"
              key={course.id}
            >
              <div className="design-courses__card">
                <img
                  src={course.icon}
                  alt={course.name}
                />
                <p>{course.name}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DesignCourses;
